document.addEventListener('DOMContentLoaded', function () {
  // Toggle discount form
  document
    .querySelectorAll('[data-checkout-discount-toggle]')
    .forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        console.log(el);
        const form = document.querySelector('[data-checkout-discount-form]');
        if (form) {
          form.hidden = !form.hidden;
          if (!form.hidden) {
            const input = form.querySelector('input[name="couponCode"]');
            if (input) {
              input.select();
              input.focus();
            }
          }
        }
      });
    });
});
